import { Paper, Typography } from "@mui/material";
import React from "react";

const EmptyMessage = ({ message, t }) => {
  return (
    <Paper variant="outlined" sx={{ m: 2, p: 2 }}>
      <Typography variant="body1" fontFamily={"Poppins"}>
        {t(`${message}`)}
      </Typography>
    </Paper>
  );
};

export default EmptyMessage;
